<div class="px-sm-3 px-md-4 ms-sm-auto py-2 font-size-sm">
  <div class="mb-2">{{ geoFilterVerbiage }}</div>
  <form #agencyFilterForm="ngForm" class="row row-cols-lg-auto g-3 align-items-center">
    <div class="col-12">
      <div class="input-group mb-2">
        <label class="input-group-text" for="agenicesFilter"><span class="visually-hidden">Filter by</span> LE Agency</label>
        <ng-container *ngIf="agencies$  | async as agencies">
          <p-multiSelect #lams [(ngModel)]="selectedAgencies" [options]="agencies" optionLabel="AgencyName" name="agencies" placeholder="All" dataKey="AgencyID" inputId="agenicesFilter" styleClass="form-select" ariaFilterLabel="Filter by Agency name" [maxSelectedLabels]="3" [showToggleAll]="false" (onChange)="onSelectAgencies($event)" [resetFilterOnHide]="true" filterBy="AgencyName" [virtualScroll]="true" [virtualScrollItemSize]="30" [panelStyle]="{width: '24rem'}">
            <ng-template let-selectedAgency pTemplate="selectedItems">
              <ng-container *ngIf="!!selectedAgency && selectedAgency.length <= 3">
                <span *ngFor="let agency of selectedAgency; last as isLast">{{agency.AgencyName}}<span *ngIf="!isLast">; </span> </span>
              </ng-container>
              <ng-container *ngIf="!!selectedAgency && selectedAgency.length > 3">{{ selectedAgency.length }} items selected</ng-container>
              <ng-container *ngIf="!selectedAgency || selectedAgency.length === 0">All</ng-container>
            </ng-template>
          </p-multiSelect>
        </ng-container>
      </div>
    </div>
  </form>
</div>
